import React, { useRef } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { nfts } from "../../../assets/data/data";
import { NextSlide, PrevSlide } from "../../../components/SliderNav";
import { DownArrow, Tether, Trotron, Verified } from "../../../IconTheme";

import Select from "react-select";

const data = [
	{ value: "ocean", label: "BSC" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];
const data2 = [
	{ value: "ocean", label: "All Status" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];
const data3 = [
	{ value: "ocean", label: "No Sort" },
	{ value: "blue", label: "ETH", isDisabled: true },
	{ value: "purple", label: "Telos" },
	{ value: "red", label: "Polygon" },
	{ value: "orange", label: "DOGE" },
	{ value: "yellow", label: "BTC" },
];

const NFT = () => {
	const sliderRef = useRef();
	const nextSlide = () => {
		sliderRef.current.slickNext();
	};
	const prevSlide = () => {
		sliderRef.current.slickPrev();
	};
	const settings = {
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		margin: 30,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};
	return (
		<section className="section-gap pb-0 overflow-hidden">
			<div className="container">
				<div className="section-title">
					<h4>Upcoming NFT Sales</h4>
					<div className="d-flex flex-wrap" style={{ gap: "24px" }}>
						<div className="floating-label-select multiple">
							<label>
								<span className="bg-body">Networks</span>
							</label>
							<Select
								closeMenuOnSelect={false}
								defaultValue={[data[2], data[1]]}
								isMulti
								options={data}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
						<div className="floating-label-select">
							<label>
								<span className="bg-body">Filter By</span>
							</label>
							<Select
								className="basic-single"
								classNamePrefix="select"
								defaultValue={data2[0]}
								name="filter"
								options={data2}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
						<div className="floating-label-select">
							<label>
								<span className="bg-body">Sort By</span>
							</label>
							<Select
								className="basic-single"
								classNamePrefix="select"
								defaultValue={data3[0]}
								name="sort"
								options={data3}
							/>
							<div className="angle-icon">
								<DownArrow />
							</div>
						</div>
					</div>
				</div>
				<div className="slider-wrapper">
					<div onClick={prevSlide}>
						<PrevSlide />
					</div>
					<div className="overflow-hidden position-relative z-99">
						<Slider {...settings} ref={sliderRef}>
							{nfts.map((item, i) => (
								<SlideItem {...item} key={i} />
							))}
						</Slider>
					</div>
					<div onClick={nextSlide}>
						<NextSlide />
					</div>
				</div>
				<div
					className="d-flex flex-wrap justify-content-center mt-2"
					style={{ columnGap: "24px", rowGap: "16px" }}
				>
					<Link to="#" className="cmn-btn">
						See More
					</Link>
					<Link to="#" className="cmn-btn secondary-btn">
						Create Token
					</Link>
				</div>
			</div>
		</section>
	);
};
export const SlideItem = ({
	NFTname,
	img,
	img2,
	img3,
	staus,
	description,
	floorPrice,
	totalSupply,
	thumbnail,
	verified,
}) => {
	return (
		<>
			<div className="slide-item">
				<div className="slide-item-thumb">
					<div className="thumb">
						<img src={img} alt={NFTname} />
						<img src={img2} alt={NFTname} />
						<img src={img3} alt={NFTname} />
					</div>
				</div>
				<div className="slide-item-content">
					<div className="content">
						<div className="slide-item-author">
							{thumbnail && <img src={thumbnail} alt="" />}
							{NFTname && (
								<h5>
									{NFTname} {verified && <Verified />}
								</h5>
							)}
							{staus && (
								<span
									className={`badge ${
										staus == "live" ? "bg-success" : "bg-warning"
									}`}
								>
									{staus}
								</span>
							)}
						</div>
						{description && <p className="description">{description}</p>}
					</div>
					<ul className="floor-info">
						<li>
							<span>Total Supply</span>
							<span>
								{staus == "live" ? <Trotron /> : <Tether />}
								{totalSupply}
							</span>
						</li>
						<li>
							<span>Floor Price</span>
							<span>{totalSupply}</span>
						</li>
						<li>
							<span>Floor Price</span>
							<span>60%</span>
						</li>
					</ul>
				</div>
				<div className="prebuy-button">
					<button type="button" className="cmn-btn w-100">
						Prebuy
					</button>
				</div>
			</div>
		</>
	);
};
export default NFT;
